/**
 * API CEI Apps
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';


// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { CeiBaseApiService } from '@cei-ufg/ngx-arquitetura-cei-commons';
import {
    MembrosDeEntidadeAcessoARecursosApiInterface
} from './membrosDeEntidadeAcessoARecursos.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class MembrosDeEntidadeAcessoARecursosApi extends CeiBaseApiService implements MembrosDeEntidadeAcessoARecursosApiInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super();
        this.initOpenApiLayer(basePath, configuration);
    }

    /**
     * Atribuir recurso de aplicação ao membro
     * Atribuição e consulta de recursos por membro.
     * @param entidadeId 
     * @param pessoaId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public entidadeMembrosAtribuirRecursoCreate(entidadeId: number, pessoaId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public entidadeMembrosAtribuirRecursoCreate(entidadeId: number, pessoaId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public entidadeMembrosAtribuirRecursoCreate(entidadeId: number, pessoaId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public entidadeMembrosAtribuirRecursoCreate(entidadeId: number, pessoaId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (entidadeId === null || entidadeId === undefined) {
            throw new Error('Required parameter entidadeId was null or undefined when calling entidadeMembrosAtribuirRecursoCreate.');
        }
        if (pessoaId === null || pessoaId === undefined) {
            throw new Error('Required parameter pessoaId was null or undefined when calling entidadeMembrosAtribuirRecursoCreate.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (jwtAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('jwtAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/entidade/${this.configuration.encodeParam({name: "entidadeId", value: entidadeId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/membros/${this.configuration.encodeParam({name: "pessoaId", value: pessoaId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/atribuir-recurso/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Atribuir recurso de aplicação ao membro
     * Atribuição e consulta de recursos por membro.
     * @param entidadeId 
     * @param pessoaId 
     * @param recursoId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public entidadeMembrosAtribuirRecursoCreate2(entidadeId: number, pessoaId: number, recursoId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public entidadeMembrosAtribuirRecursoCreate2(entidadeId: number, pessoaId: number, recursoId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public entidadeMembrosAtribuirRecursoCreate2(entidadeId: number, pessoaId: number, recursoId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public entidadeMembrosAtribuirRecursoCreate2(entidadeId: number, pessoaId: number, recursoId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (entidadeId === null || entidadeId === undefined) {
            throw new Error('Required parameter entidadeId was null or undefined when calling entidadeMembrosAtribuirRecursoCreate2.');
        }
        if (pessoaId === null || pessoaId === undefined) {
            throw new Error('Required parameter pessoaId was null or undefined when calling entidadeMembrosAtribuirRecursoCreate2.');
        }
        if (recursoId === null || recursoId === undefined) {
            throw new Error('Required parameter recursoId was null or undefined when calling entidadeMembrosAtribuirRecursoCreate2.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (jwtAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('jwtAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/entidade/${this.configuration.encodeParam({name: "entidadeId", value: entidadeId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/membros/${this.configuration.encodeParam({name: "pessoaId", value: pessoaId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/atribuir-recurso/${this.configuration.encodeParam({name: "recursoId", value: recursoId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Revogar recurso de aplicação do membro
     * Atribuição e consulta de recursos por membro.
     * @param entidadeId 
     * @param pessoaId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public entidadeMembrosAtribuirRecursoDestroy(entidadeId: number, pessoaId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public entidadeMembrosAtribuirRecursoDestroy(entidadeId: number, pessoaId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public entidadeMembrosAtribuirRecursoDestroy(entidadeId: number, pessoaId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public entidadeMembrosAtribuirRecursoDestroy(entidadeId: number, pessoaId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (entidadeId === null || entidadeId === undefined) {
            throw new Error('Required parameter entidadeId was null or undefined when calling entidadeMembrosAtribuirRecursoDestroy.');
        }
        if (pessoaId === null || pessoaId === undefined) {
            throw new Error('Required parameter pessoaId was null or undefined when calling entidadeMembrosAtribuirRecursoDestroy.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (jwtAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('jwtAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/entidade/${this.configuration.encodeParam({name: "entidadeId", value: entidadeId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/membros/${this.configuration.encodeParam({name: "pessoaId", value: pessoaId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/atribuir-recurso/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Revogar recurso de aplicação do membro
     * Atribuição e consulta de recursos por membro.
     * @param entidadeId 
     * @param pessoaId 
     * @param recursoId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public entidadeMembrosAtribuirRecursoDestroy2(entidadeId: number, pessoaId: number, recursoId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public entidadeMembrosAtribuirRecursoDestroy2(entidadeId: number, pessoaId: number, recursoId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public entidadeMembrosAtribuirRecursoDestroy2(entidadeId: number, pessoaId: number, recursoId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public entidadeMembrosAtribuirRecursoDestroy2(entidadeId: number, pessoaId: number, recursoId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (entidadeId === null || entidadeId === undefined) {
            throw new Error('Required parameter entidadeId was null or undefined when calling entidadeMembrosAtribuirRecursoDestroy2.');
        }
        if (pessoaId === null || pessoaId === undefined) {
            throw new Error('Required parameter pessoaId was null or undefined when calling entidadeMembrosAtribuirRecursoDestroy2.');
        }
        if (recursoId === null || recursoId === undefined) {
            throw new Error('Required parameter recursoId was null or undefined when calling entidadeMembrosAtribuirRecursoDestroy2.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (jwtAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('jwtAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/entidade/${this.configuration.encodeParam({name: "entidadeId", value: entidadeId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/membros/${this.configuration.encodeParam({name: "pessoaId", value: pessoaId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/atribuir-recurso/${this.configuration.encodeParam({name: "recursoId", value: recursoId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Listar recursos atribuídos ao membro
     * Atribuição e consulta de recursos por membro.
     * @param entidadeId 
     * @param pessoaId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public entidadeMembrosAtribuirRecursoRetrieve(entidadeId: number, pessoaId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public entidadeMembrosAtribuirRecursoRetrieve(entidadeId: number, pessoaId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public entidadeMembrosAtribuirRecursoRetrieve(entidadeId: number, pessoaId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public entidadeMembrosAtribuirRecursoRetrieve(entidadeId: number, pessoaId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (entidadeId === null || entidadeId === undefined) {
            throw new Error('Required parameter entidadeId was null or undefined when calling entidadeMembrosAtribuirRecursoRetrieve.');
        }
        if (pessoaId === null || pessoaId === undefined) {
            throw new Error('Required parameter pessoaId was null or undefined when calling entidadeMembrosAtribuirRecursoRetrieve.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (jwtAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('jwtAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/entidade/${this.configuration.encodeParam({name: "entidadeId", value: entidadeId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/membros/${this.configuration.encodeParam({name: "pessoaId", value: pessoaId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/atribuir-recurso/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Listar recursos atribuídos ao membro
     * Atribuição e consulta de recursos por membro.
     * @param entidadeId 
     * @param pessoaId 
     * @param recursoId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public entidadeMembrosAtribuirRecursoRetrieve2(entidadeId: number, pessoaId: number, recursoId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public entidadeMembrosAtribuirRecursoRetrieve2(entidadeId: number, pessoaId: number, recursoId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public entidadeMembrosAtribuirRecursoRetrieve2(entidadeId: number, pessoaId: number, recursoId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public entidadeMembrosAtribuirRecursoRetrieve2(entidadeId: number, pessoaId: number, recursoId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (entidadeId === null || entidadeId === undefined) {
            throw new Error('Required parameter entidadeId was null or undefined when calling entidadeMembrosAtribuirRecursoRetrieve2.');
        }
        if (pessoaId === null || pessoaId === undefined) {
            throw new Error('Required parameter pessoaId was null or undefined when calling entidadeMembrosAtribuirRecursoRetrieve2.');
        }
        if (recursoId === null || recursoId === undefined) {
            throw new Error('Required parameter recursoId was null or undefined when calling entidadeMembrosAtribuirRecursoRetrieve2.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (jwtAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('jwtAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/entidade/${this.configuration.encodeParam({name: "entidadeId", value: entidadeId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/membros/${this.configuration.encodeParam({name: "pessoaId", value: pessoaId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/atribuir-recurso/${this.configuration.encodeParam({name: "recursoId", value: recursoId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Atribuir recurso de aplicação ao membro
     * Atribuição e consulta de recursos por membro.
     * @param entidadeId 
     * @param pessoaId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public entidadeMembrosRecursosAtribuidosCreate(entidadeId: number, pessoaId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public entidadeMembrosRecursosAtribuidosCreate(entidadeId: number, pessoaId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public entidadeMembrosRecursosAtribuidosCreate(entidadeId: number, pessoaId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public entidadeMembrosRecursosAtribuidosCreate(entidadeId: number, pessoaId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (entidadeId === null || entidadeId === undefined) {
            throw new Error('Required parameter entidadeId was null or undefined when calling entidadeMembrosRecursosAtribuidosCreate.');
        }
        if (pessoaId === null || pessoaId === undefined) {
            throw new Error('Required parameter pessoaId was null or undefined when calling entidadeMembrosRecursosAtribuidosCreate.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (jwtAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('jwtAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/entidade/${this.configuration.encodeParam({name: "entidadeId", value: entidadeId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/membros/${this.configuration.encodeParam({name: "pessoaId", value: pessoaId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/recursos-atribuidos/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Revogar recurso de aplicação do membro
     * Atribuição e consulta de recursos por membro.
     * @param entidadeId 
     * @param pessoaId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public entidadeMembrosRecursosAtribuidosDestroy(entidadeId: number, pessoaId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public entidadeMembrosRecursosAtribuidosDestroy(entidadeId: number, pessoaId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public entidadeMembrosRecursosAtribuidosDestroy(entidadeId: number, pessoaId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public entidadeMembrosRecursosAtribuidosDestroy(entidadeId: number, pessoaId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (entidadeId === null || entidadeId === undefined) {
            throw new Error('Required parameter entidadeId was null or undefined when calling entidadeMembrosRecursosAtribuidosDestroy.');
        }
        if (pessoaId === null || pessoaId === undefined) {
            throw new Error('Required parameter pessoaId was null or undefined when calling entidadeMembrosRecursosAtribuidosDestroy.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (jwtAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('jwtAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/entidade/${this.configuration.encodeParam({name: "entidadeId", value: entidadeId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/membros/${this.configuration.encodeParam({name: "pessoaId", value: pessoaId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/recursos-atribuidos/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Listar recursos atribuídos ao membro
     * Atribuição e consulta de recursos por membro.
     * @param entidadeId 
     * @param pessoaId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public entidadeMembrosRecursosAtribuidosRetrieve(entidadeId: number, pessoaId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public entidadeMembrosRecursosAtribuidosRetrieve(entidadeId: number, pessoaId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public entidadeMembrosRecursosAtribuidosRetrieve(entidadeId: number, pessoaId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public entidadeMembrosRecursosAtribuidosRetrieve(entidadeId: number, pessoaId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (entidadeId === null || entidadeId === undefined) {
            throw new Error('Required parameter entidadeId was null or undefined when calling entidadeMembrosRecursosAtribuidosRetrieve.');
        }
        if (pessoaId === null || pessoaId === undefined) {
            throw new Error('Required parameter pessoaId was null or undefined when calling entidadeMembrosRecursosAtribuidosRetrieve.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (jwtAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('jwtAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/entidade/${this.configuration.encodeParam({name: "entidadeId", value: entidadeId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/membros/${this.configuration.encodeParam({name: "pessoaId", value: pessoaId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/recursos-atribuidos/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
